// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){
 
  //wait until images, links, fonts, stylesheets, and js is loaded
  window.addEventListener("load", function() {

    const eventsSwiper = document.querySelector('.eventsSwiper');
    if(eventsSwiper) {
      const eventsSwiperOptions = JSON.parse(eventsSwiper.getAttribute('data-swiper'));
      /* Slider initialisieren */
      const eventsSwiperInstance = new Swiper(eventsSwiper, eventsSwiperOptions);
    }

   }, false);
 
 });